import React, { Component } from 'react';
import qs from 'qs';
import { connect } from 'react-redux';
import { getRunApi } from '../../experiment-tracking/actions';
import { getUUID } from '../../common/utils/ActionUtils';
import {
  getRegisteredModelApi,
  getModelVersionApi,
  getModelVersionArtifactApi,
  parseMlModelFile,
} from '../actions';
import RequestStateWrapper from '../../common/components/RequestStateWrapper';
import { CompareModelVersionsView } from './CompareModelVersionsView';
import _ from 'lodash';
import { PageContainer } from '../../common/components/PageContainer';

type CompareModelVersionsPageImplProps = {
  modelName: string;
  versionsToRuns: any;
  getRunApi: (...args: any[]) => any;
  getRegisteredModelApi: (...args: any[]) => any;
  getModelVersionApi: (...args: any[]) => any;
  getModelVersionArtifactApi: (...args: any[]) => any;
  parseMlModelFile: (...args: any[]) => any;
};

type CompareModelVersionsPageImplState = any;

// TODO: Write integration tests for this component
export class CompareModelVersionsPageImpl extends Component<
  CompareModelVersionsPageImplProps,
  CompareModelVersionsPageImplState
> {
  registeredModelRequestId = getUUID();
  versionRequestId = getUUID();
  runRequestId = getUUID();
  getMlModelFileRequestId = getUUID();

  state = {
    requestIds: [
      // requests that must be fulfilled before rendering
      this.registeredModelRequestId,
      this.runRequestId,
      this.versionRequestId,
      this.getMlModelFileRequestId,
    ],
    requestIdsWith404ErrorsToIgnore: [this.runRequestId, this.getMlModelFileRequestId],
  };

  removeRunRequestId() {
    this.setState((prevState: any) => ({
      requestIds: _.without(prevState.requestIds, this.runRequestId),
    }));
  }

  componentDidMount() {
    this.props.getRegisteredModelApi(this.props.modelName, this.registeredModelRequestId);
    for (const modelVersion in this.props.versionsToRuns) {
      if ({}.hasOwnProperty.call(this.props.versionsToRuns, modelVersion)) {
        const runID = this.props.versionsToRuns[modelVersion];
        if (runID) {
          this.props.getRunApi(runID, this.runRequestId).catch(() => {
            // Failure of this call should not block the page. Here we remove
            // `runRequestId` from `requestIds` to unblock RequestStateWrapper
            // from rendering its content
            this.removeRunRequestId();
          });
        } else {
          this.removeRunRequestId();
        }
        const { modelName } = this.props;
        this.props.getModelVersionApi(modelName, modelVersion, this.versionRequestId);
        this.props
          .getModelVersionArtifactApi(modelName, modelVersion)
          .then((content: any) =>
            this.props.parseMlModelFile(
              modelName,
              modelVersion,
              content.value,
              this.getMlModelFileRequestId,
            ),
          )
          .catch(() => {
            // Failure of this call chain should not block the page. Here we remove
            // `getMlModelFileRequestId` from `requestIds` to unblock RequestStateWrapper
            // from rendering its content
            this.setState((prevState: any) => ({
              requestIds: _.without(prevState.requestIds, this.getMlModelFileRequestId),
            }));
          });
      }
    }
  }

  render() {
    return (
      <PageContainer>
        <RequestStateWrapper
          requestIds={this.state.requestIds}
          requestIdsWith404sToIgnore={this.state.requestIdsWith404ErrorsToIgnore}
        >
          <CompareModelVersionsView
            modelName={this.props.modelName}
            versionsToRuns={this.props.versionsToRuns}
          />
        </RequestStateWrapper>
      </PageContainer>
    );
  }
}

const mapStateToProps = (state: any, ownProps: any) => {
  const { location } = ownProps;
  const searchValues = qs.parse(location.search);
  // @ts-expect-error TS(2345): Argument of type 'string | string[] | ParsedQs | P... Remove this comment to see the full error message
  const modelName = decodeURIComponent(JSON.parse(searchValues['?name']));
  // @ts-expect-error TS(2345): Argument of type 'string | string[] | ParsedQs | P... Remove this comment to see the full error message
  const versionsToRuns = JSON.parse(searchValues['runs']);
  return { modelName, versionsToRuns };
};

const mapDispatchToProps = {
  getRunApi,
  getRegisteredModelApi,
  getModelVersionApi,
  getModelVersionArtifactApi,
  parseMlModelFile,
};

export const CompareModelVersionsPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CompareModelVersionsPageImpl);
